// const urlBase = "http://localhost:8080/api/v1";
// const urlBase = "http://192.168.0.9:8080/api/v1";
// const urlBase = "http://www.murphy.com.py/api/v1";
const CONFIG = {};

export const setConfig = (configJson) => {
  const getValueByEnv = (property) => {
    const seguEnv = process.env.REACT_APP_SEGU360_ENV;
    if (seguEnv) {
      const encontrado = configJson[`${property}_${seguEnv.toUpperCase()}`];
      if (encontrado) {
        return encontrado;
      }
    }
    return configJson[property];
  };
  CONFIG.URL_BASE = getValueByEnv('REACT_APP_URL_BASE');
  CONFIG.URL_WEB = getValueByEnv('REACT_APP_URL_WEB');

  CONFIG.TITULO = configJson.REACT_APP_TITULO;
  CONFIG.TITULO_CORTO = configJson.REACT_APP_TITULO_CORTO;
  CONFIG.COLOR_PRIMARY = configJson.REACT_APP_COLOR_PRIMARY;
  CONFIG.FAVICON = configJson.REACT_APP_FAVICON;
  CONFIG.LOGO_300x300 = configJson.REACT_APP_LOGO_300x300;

  CONFIG.WITH_LOGIN = configJson.REACT_APP_WITH_LOGIN;

  CONFIG.RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
  CONFIG.GOOGLE_ANALYTICS_TRACKING_CODE =
    process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE;
  CONFIG.GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  CONFIG.PAGOS_URL = process.env.REACT_APP_PAGOS_URL;
  CONFIG.PAGOS_API_KEY = process.env.REACT_APP_PAGOS_API_KEY;
  CONFIG.AMBIENTE = process.env.REACT_APP_AMBIENTE;
  CONFIG.JWT_KEY = process.env.REACT_APP_JWT_PASSWORD;
  CONFIG.RECAPTCHA_V2_KEY = process.env.REACT_APP_RECAPTCHA_V2_KEY;
  CONFIG.RECAPTCHA_V2_LOCAL_KEY = process.env.REACT_APP_RECAPTCHA_V2_LOCAL_KEY;
};

const compressionOptions = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true
};

const LINKS_PRODUCTOS = {
  VEHICULO: 'vehiculo',
  PERSONAL: 'personal',
  VIDA: 'vida',
  HOGAR: 'hogar',
  COMERCIO: 'comercio',
  FINANZAS: 'finanzas',
  VIAJE: 'viaje'
};

const TIPOS_PRODUCTOS = [
  { codigo: 1, link: LINKS_PRODUCTOS.VEHICULO },
  { codigo: 2, link: LINKS_PRODUCTOS.PERSONAL },
  { codigo: 3, link: LINKS_PRODUCTOS.VIDA },
  { codigo: 4, link: LINKS_PRODUCTOS.HOGAR },
  { codigo: 5, link: LINKS_PRODUCTOS.COMERCIO },
  { codigo: 6, link: LINKS_PRODUCTOS.FINANZAS },
  { codigo: 8, link: LINKS_PRODUCTOS.VIAJE }
];

const ESTADOS = [
  { descripcion: 'SOLTERO' },
  { descripcion: 'CASADO' },
  { descripcion: 'DIVORCIADO' },
  { descripcion: 'VIUDO' }
];

const TIPOS_DOCUMENTO = [
  { codigo: 1, descripcion: 'CI' },
  { codigo: 2, descripcion: 'RUC' },
  { codigo: 3, descripcion: 'Extranjero/a' }
];

const TIPOS_JOB = [
  { codigo: 'CIERRE_ASEGURADORA', descripcion: 'Cierre Aseguradora' },
  { codigo: 'VERIFICAR_CONEXION', descripcion: 'Verificar Conexion' },
  { codigo: 'BLOQUEO_POLIZA', descripcion: 'Bloqueo Poliza' }
];

const NACIONALIDADES = [{ descripcion: 'PARAGUAYA' }, { descripcion: 'OTROS' }];

const UNIDAD_MEDIDA_FECHAS = [
  {
    codigo: 'dia',
    descripcion: 'Día/s',
    cantidad_dias: 1,
    codigo_moment: 'days'
  },
  {
    codigo: 'mes',
    descripcion: 'Mes/es',
    cantidad_dias: 30,
    codigo_moment: 'months'
  },
  {
    codigo: 'anho',
    descripcion: 'Año/s',
    cantidad_dias: 365,
    codigo_moment: 'years'
  }
];

const FORMAS_EMISION = [
  { codigo: 'multi_anual', descripcion: 'Todo el periodo' },
  { codigo: 'anual_renovable', descripcion: 'Renovable' }
];

const PERIODOS_CORTOS = [
  { codigo: 'periodo_corto', descripcion: 'Tabla de Periodo Corto' },
  { codigo: 'prorrata', descripcion: 'Prorrata' }
];

const CANTIDAD_PAGOS_TODOS = [
  { codigo: 1, descripcion: '1 (Un) Pago' },
  { codigo: 2, descripcion: '2 (Dos) Pagos' },
  { codigo: 3, descripcion: '3 (Tres) Pagos' },
  { codigo: 4, descripcion: '4 (Cuatro) Pagos' },
  { codigo: 6, descripcion: '6 (Seis) Pagos' },
  { codigo: 12, descripcion: '12 (Doce) Pagos' }
];

const MOMENT_CANTIDAD_UNIDAD_MEDIDA = [
  {
    codigo: 'diario',
    cantidad: 1,
    codigo_moment: 'days'
  },
  {
    codigo: 'semanal',
    cantidad: 7,
    codigo_moment: 'days'
  },
  {
    codigo: 'mensual',
    cantidad: 1,
    codigo_moment: 'months'
  },
  {
    codigo: 'bimestral',
    cantidad: 2,
    codigo_moment: 'months'
  },
  {
    codigo: 'trimestral',
    cantidad: 3,
    codigo_moment: 'months'
  },

  {
    codigo: 'semestral',
    cantidad: 6,
    codigo_moment: 'months'
  },
  {
    codigo: 'anual',
    cantidad: 1,
    codigo_moment: 'years'
  }
];

const TIPOS_COMBUSTIBLE = [
  { codigo: 'DIESEL', descripcion: 'Diesel' },
  { codigo: 'NAFTA', descripcion: 'Nafta' },
  { codigo: 'FLEX', descripcion: 'Flex' },
  { codigo: 'HIBRIDO', descripcion: 'Híbrido' },
  { codigo: 'ELECTRICO', descripcion: 'Eléctrico' },
  { codigo: 'GLP', descripcion: 'GLP' }
];

const TIPOS_VEHICULO = [
  'AUTOMOVIL',
  'CAMIONETA_PICKUP',
  'CAMIONETA',
  'FURGON',
  'CAMION',
  'BUS',
  'REMOLQUE',
  'TRACTOCAMION',
  'SEMIREMOLQUE',
  'MAQUINARIAS_AGRICOLAS',
  'MOTO',
  'EMBARCACION',
  'AMBULANCIA',
  'MAQUINARIAS'
];

const TIPOS_TRANSMISION = ['AUTOMATICO', 'MECANICO'];

const TIPOS_TRACCION = ['4X4', '4X2'];

const TIPOS_DETALLE_VEHICULO = [
  'MONTACARGAS',
  'RETROEXCAVADORA',
  'PALA CARGADORA',
  'COUPE',
  'TRACTOR',
  'SEDAN',
  'OTRAS MAQUINARIAS',
  'C/P',
  'FURGONETA',
  'MAQUINAS PESADAS',
  'EXCAVADORA',
  'HATCHBACK',
  'CABRIOLET',
  'D/C',
  'C/S',
  'SUV'
];

const TIPOS_VEHICULO_SUBMODELO = [
  { codigo: 1, descripcion: 'AUTOMOVIL' },
  { codigo: 2, descripcion: 'CAMIONETA_PICKUP' },
  { codigo: 3, descripcion: 'CAMIONETA' },
  { codigo: 4, descripcion: 'FURGON' },
  { codigo: 5, descripcion: 'CAMION' },
  { codigo: 6, descripcion: 'BUS' },
  { codigo: 7, descripcion: 'REMOLQUE' },
  { codigo: 8, descripcion: 'TRACTOCAMION' },
  { codigo: 9, descripcion: 'SEMIREMOLQUE' },
  { codigo: 10, descripcion: 'MAQUINARIAS_AGRICOLAS' },
  { codigo: 11, descripcion: 'MOTO' },
  { codigo: 12, descripcion: 'EMBARCACION' },
  { codigo: 13, descripcion: 'AMBULANCIA' },
  { codigo: 14, descripcion: 'MAQUINARIAS' }
];

const TIPOS_USO_VEHICULO = [
  { codigo: 'PARTICULAR', descripcion: 'Particular' },
  { codigo: 'COMERCIAL', descripcion: 'Comercial' },
  { codigo: 'PLATAFORMA', descripcion: 'Plataforma (Muv, Uber, Bolt, etc.)' },
  { codigo: 'OTROS', descripcion: 'Otros' }
];

const TIPOS_USO_VEHICULO_OTROS = [
  { codigo: 'TAXI', descripcion: 'Taxi / Remise' },
  { codigo: 'TRANSPORTE', descripcion: 'Emp. de Transporte' },
  { codigo: 'TRANSPORTE_ESCOLAR', descripcion: 'Transporte Escolar' }
];

const TIPOS_USO_VEHICULO_TODOS = [
  ...TIPOS_USO_VEHICULO,
  ...TIPOS_USO_VEHICULO_OTROS
];

const USER_STATES = {
  notLogged: '1',
  loggingStart: '2',
  loggingEnd: '3'
};
const MOTIVO_ANULACION_SELECT = [
  { codigo: 'POR_VENTA', descripcion: 'Por venta' },
  { codigo: 'MOTIVOS_ECONOMICOS', descripcion: 'Motivos económicos' },
  {
    codigo: 'INSATISFACION',
    descripcion: 'Estoy insatisfecho con el servicio recibido'
  },
  { codigo: 'OTROS_MOTIVOS', descripcion: 'Otro motivo' }
];

const COMENTARIOS_ADICIONALES_ANULACION = {
  codigo: 'comments',
  descripcion: 'Comentarios adicionales'
};
const OTROS_MOTIVOS_ANULACION = {
  codigo: 'OTROS_MOTIVOS_ANULACION',
  descripcion: 'Otro motivo'
};

const FRANQUICIA_DESDE_HASTA = [
  { codigo: 1, descripcion: '1º Siniestro' },
  { codigo: 2, descripcion: '2º Siniestro' },
  { codigo: 3, descripcion: '3º Siniestro' },
  { codigo: 4, descripcion: '4º Siniestro' },
  { codigo: 5, descripcion: '5º Siniestro' },
  { codigo: 6, descripcion: '6º Siniestro' },
  { codigo: 7, descripcion: '7º Siniestro' },
  { codigo: 8, descripcion: '8º Siniestro' },
  { codigo: 9, descripcion: '9º Siniestro' },
  { codigo: 10, descripcion: '10º Siniestro' }
];

export {
  CANTIDAD_PAGOS_TODOS,
  COMENTARIOS_ADICIONALES_ANULACION,
  compressionOptions,
  CONFIG,
  ESTADOS,
  FORMAS_EMISION,
  FRANQUICIA_DESDE_HASTA,
  LINKS_PRODUCTOS,
  MOMENT_CANTIDAD_UNIDAD_MEDIDA,
  MOTIVO_ANULACION_SELECT,
  NACIONALIDADES,
  OTROS_MOTIVOS_ANULACION,
  PERIODOS_CORTOS,
  TIPOS_COMBUSTIBLE,
  TIPOS_DETALLE_VEHICULO,
  TIPOS_DOCUMENTO,
  TIPOS_JOB,
  TIPOS_PRODUCTOS,
  TIPOS_TRACCION,
  TIPOS_TRANSMISION,
  TIPOS_USO_VEHICULO,
  TIPOS_USO_VEHICULO_OTROS,
  TIPOS_USO_VEHICULO_TODOS,
  TIPOS_VEHICULO,
  TIPOS_VEHICULO_SUBMODELO,
  UNIDAD_MEDIDA_FECHAS,
  USER_STATES
};
